export function generateRecommendations(itemsToday, { costsDat, poDat, customersDat, suppliersDat, invoicesDat }) {
  // --- Normalize data ---
  const costs = Array.isArray(costsDat)
    ? costsDat.map(c => ({ ...c, amount: parseFloat(c.amount) }))
    : [];

  const purchaseOrders = Array.isArray(poDat) ? poDat : [];

  const today = new Date();
  const currentMonth = today.getMonth() + 1;
  const currentYear = today.getFullYear();

  const customers = Array.isArray(customersDat)
    ? customersDat
        .map(c => ({
          id: Number(c.Id),
          name: c.Name,
          revenue: Number(c.Revenue || 0),
          growth: c.Growth,
          region: c.Region,
          month: c.month,
          typeImport: c.Type,
        }))
        .filter(c => {
          if (!c.month) return false;
          const [year, month] = c.month.split("-").map(Number);
          return year === currentYear && month === currentMonth;
        })
        .sort((a, b) => b.revenue - a.revenue)
    : [];

  const suppliers = Array.isArray(suppliersDat)
    ? suppliersDat
        .map(s => ({
          id: Number(s.Id),
          name: s.Name,
          purchase: Number(s.Purchase || 0),
          region: s.Region,
          month: s.month,
          typeImport: s.Type,
        }))
        .filter(s => {
          if (!s.month) return false;
          const [year, month] = s.month.split("-").map(Number);
          return year === currentYear && month === currentMonth;
        })
        .sort((a, b) => b.purchase - a.purchase)
    : [];

  const invoices = Array.isArray(invoicesDat) ? invoicesDat : [];

  // --- Compute recommendations ---
  const recommendations = [];
  if (!itemsToday || itemsToday.length === 0) return recommendations;

  const currentMonthWord = today.toLocaleString("en-US", { month: "long" });

  for (const row of itemsToday) {
    const { Id, TableName, CustomerName, ChangeType } = row;
    let message = "🟢 Looks good.";

    switch (TableName) {
      case "PurchaseOrders": {
        const poExists = purchaseOrders.some(p => p.Id === Number(CustomerName));

        if (!poExists && ChangeType !== "Deleted") {
          message = "🟢 PO Deleted, looks good.";
        } else if (poExists) {
          const costExists = costs.some(c => c.poId === Number(CustomerName));
          if (ChangeType !== "Deleted" && !costExists) {
            message = `⚠️ Add Purchase Order ID: ${Number(CustomerName)} to Costs table.`;
          }

          const supplierExists = suppliers.some(s => s.name === CustomerName);
          if (!supplierExists) {
            message = `⚠️ Supplier with name ${CustomerName} was not found in Customer/Supplier Data for ${currentMonthWord}.`;
          }
        }

        recommendations.push({ Id, type: "PurchaseOrders", message });
        break;
      }

      case "Invoices": {
        const invoiceExists = invoices.some(inv => inv.Id === Number(CustomerName));
        const customerExists = customers.some(c => c.name === CustomerName);

        if (invoiceExists && !customerExists) {
          message = `⚠️ Customer with name ${CustomerName} was not found in Customer/Supplier Data for ${currentMonthWord}.`;
        }

        recommendations.push({ Id, type: "Invoices", message });
        break;
      }

      default: {
        recommendations.push({ Id, type: TableName, message });
        break;
      }
    }
  }

  return recommendations;
}
